import React, { MouseEventHandler } from "react";
import ContainerComponent from "../../../../components/Container/ContainerComponent";
import ButtonComponent from "../../../../components/Button/ButtonComponent";
import TypographyComponent from "../../../../components/Typography/ThypographyComponent";
import BoxComponent from "../../../../components/Box/BoxComponent";
import ImageLogoComponent from "../../../../components/Image/ImageLogoComponent";
import PresenteIcon from "../../../../assets/icons/caixa_presente.png";

interface InfoFidelidadeProps {
    descricao: string;
    onClickFidelidade: MouseEventHandler<HTMLButtonElement>;
}

const InfoFidelidadeComponent = (props: InfoFidelidadeProps) => {
    return <ContainerComponent
        component="section"
        sx={{
            display: 'flex',
            flexDirection: 'column',
            mt: 0.5,
        }}
    >
        <ButtonComponent
            id="botao_programa_fidelidade"
            variant="outlined"
            onClick={props.onClickFidelidade}
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                borderColor: "#FFC9C9",
                height: {
                    xs: "auto",
                    sm: "91.2px"
                },
                borderRadius: "15px",
                gap: 2
            }}
        >
            <BoxComponent
                component="div"
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    width: {
                        xs: "15%",
                        sm: "8%",
                        md: "5%"
                    },
                    height: {
                        xs: "15%",
                        sm: "8%",
                        md: "5%"
                    },
                    borderRadius: 50
                }}
            >
                <BoxComponent
                    component="div"
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        backgroundColor: "#E7000B",
                        borderRadius: 50,
                        width: 48,
                        height: 48    
                    }}
                >
                    <ImageLogoComponent
                        sx={{
                            width: 25,
                            height: 25,
                            color: "#1F2937",
                            borderRadius: 0,
                            margin: 0,
                            marginLeft: 0.35,
                            marginBottom: 0.2

                        }}
                        src={PresenteIcon}
                        alt="icon_presente"
                    />
                </BoxComponent>
            </BoxComponent>
            <BoxComponent
                component="div"
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    width: {
                        xs: "85%",
                        sm: "92%",
                        md: "95%"
                    },
                    height: {
                        xs: "85%",
                        sm: "92%",
                        md: "95%"
                    },
                }}
            >
                <TypographyComponent
                    variant="h3"
                    sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        alignContent: "center",
                        gap: 1,
                        textTransform: "initial",
                        color: "#101828",

                        fontFamily: '"Font 2", "Roboto", "Arial", sans-serif',
                        fontWeight: 700,
                        fontSize: {
                            xs: "1.30rem",
                            md: '1.25rem',   // Mapeamento do 's+' para 20px (20/16)
                        },
                        lineHeight: 1.6,       // 32px / 20px = 1.6
                        letterSpacing: '0em'
                    }}
                    fontWeight="bold"
                >
                    Programa de fidelidade
                </TypographyComponent>
                <TypographyComponent
                    variant="body1"
                    sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        alignContent: "center",
                        gap: 1,
                        textTransform: "initial",
                        color: "#4A5565",
                        fontFamily: '"Font 7", "Roboto", "Helvetica", "Arial", sans-serif',
                        fontWeight: 400,
                        fontSize: {
                            xs: "1rem",
                            md: '0.875rem',  // 14px / 16px
                        },
                        textAlign: "left",
                        lineHeight: 1.42857,   // 20px / 14px
                        letterSpacing: '0em'
                    }}
                >
                    {props.descricao}

                </TypographyComponent>
            </BoxComponent>
        </ButtonComponent>
    </ContainerComponent>
}

export default InfoFidelidadeComponent;